<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="fade-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="hexColor"
        :label="$attrs.label"
        v-on="on"
        :rules="rules"
        :disabled="$attrs.disabled"
        :readonly="$attrs.readonly"
        @input="updateHexColor"
        
      >
        <template v-slot:prepend>
          <v-icon :color="hexColor">mdi-square</v-icon>
        </template>
      </v-text-field>
    </template>
    <v-color-picker
      v-model="color"
      v-bind="$attrs"
      :hide-mode-switch="true"
      @input="updateHexColor"
      :mode="'hexa'"
    >
    </v-color-picker>
  </v-menu>
</template>
<script>
import { ednRequired } from "./mixins/ednRequired";

export default {
  inheritAttrs: false,
  mixins: [ednRequired],

  props: {
    value: {
      type: String,
      default: () => "#FFFFFF"
    }
  },
  data() {
    return {
      menu: null,
      color: "",
      hexColor: "",
      colors: {
        primary: this.$vuetify.theme.currentTheme.primary,
        secondary: this.$vuetify.theme.currentTheme.secondary
      }
    };
  },
  created() {
    this.color = this.value;
    this.hexColor = this.value;
  },
  watch: {
  },
  methods: {
    // Update hexa color when color picker is changed or when input is changed
    updateHexColor(newColor) {
      this.hexColor = newColor;
      this.$emit("input", newColor);
    }
  }
};
</script>

